import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('NiotaClassic.DeviceTypes.form.titleUpdate') : _vm.$i18n_t('NiotaClassic.DeviceTypes.form.titleCreate')) + "\n    " + _vm._s(_vm.formItem.id ? ` - ${_vm.formItem.title}` : '') + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.formValid,
            "prepend-icon": "fa-save"
          },
          on: {
            "click": _vm.createOrUpdateDeviceType
          }
        }, [_vm._v("\n      " + _vm._s(_vm.formItem.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.saveAndCreate')) + "\n    ")])];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [!_vm.isEditForm ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCombobox, {
    attrs: {
      "data-cy": "copy_deviceType",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "item-text": "title",
      "item-value": "id",
      "return-object": "",
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.copyDeviceType'),
      "loading": _vm.deviceTypes.length === 0
    },
    on: {
      "input": _vm.handleImport
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('div', {
    staticClass: "image-upload-wrapper",
    on: {
      "click": function ($event) {
        return _vm.$refs.attachmentInput.click();
      }
    }
  }, [_c('img', {
    staticClass: "image-upload-img",
    attrs: {
      "src": _vm.formItem.image ? _vm.niota1ImageUrl(_vm.formItem.image) : 'img/niota-classic/placeholder.png'
    }
  }), _c('input', {
    ref: "attachmentInput",
    staticStyle: {
      "visibility": "hidden",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.imageInputChanged
    }
  })])])])], 1), _vm.formItem.id || _vm.isSuperSystemAdmin ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "certifiedBy",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.certifiedBy'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": ""
    },
    on: {
      "input": _vm.updateModel
    },
    model: {
      value: _vm.formItem.properties.certifiedBy,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "certifiedBy", $$v);
      },
      expression: "formItem.properties.certifiedBy"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "data-cy": "checkbox_sertified",
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.certified'),
      "disabled": !_vm.isSuperSystemAdmin || _vm.formSaving,
      "color": _vm.color
    },
    on: {
      "input": _vm.updateModel
    },
    model: {
      value: _vm.formItem.properties.certified,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "certified", $$v);
      },
      expression: "formItem.properties.certified"
    }
  })], 1)], 1) : _vm._e(), _vm.showImportClipboard ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "import_niota",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.importNiota'),
      "placeholder": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.importNiotaPlaceholder'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "append-icon": "fal fa-copy"
    },
    on: {
      "click:append": _vm.handleImportClipboard
    },
    model: {
      value: _vm.niotaImportClipboard,
      callback: function ($$v) {
        _vm.niotaImportClipboard = $$v;
      },
      expression: "niotaImportClipboard"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "data-cy": "devicetype_title",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.title'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.formItem.title,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "title", $$v);
      },
      expression: "formItem.title"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "data-cy": "visibility",
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.visibility'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "items": _vm.visibilityItems,
      "hide-details": "auto",
      "menu-props": {
        contentClass: 'v-menu__content--visibility'
      }
    },
    model: {
      value: _vm.formItem.visibility,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "visibility", $$v);
      },
      expression: "formItem.visibility"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VSelect, {
    staticClass: "required",
    attrs: {
      "data-cy": "account",
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.account'),
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "items": _vm.accounts,
      "item-text": "name",
      "hide-details": "auto",
      "return-object": "",
      "menu-props": {
        contentClass: 'v-menu__content--account'
      }
    },
    on: {
      "input": _vm.accountUpdated
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.name))]), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Common.table.id')) + ": " + _vm._s(data.item.id) + "\n                ")])], 1)];
      }
    }]),
    model: {
      value: _vm.formItem.account,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "account", $$v);
      },
      expression: "formItem.account"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c(VTextarea, {
    attrs: {
      "data-cy": "description",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.description'),
      "hide-details": "auto",
      "autocomplete": "off",
      "required": "",
      "rows": "4"
    },
    model: {
      value: _vm.formItem.description,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "description", $$v);
      },
      expression: "formItem.description"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "manufacturer_DeviceName",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.manufacturerDeviceName'),
      "hide-details": "auto",
      "autocomplete": "off",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.manufacturer.device_name,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties.manufacturer, "device_name", $$v);
      },
      expression: "formItem.properties.manufacturer.device_name"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "heartBeats",
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.heartbeats'),
      "hide-details": "auto",
      "autocomplete": "off",
      "type": "number",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.expected_packets,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "expected_packets", $$v);
      },
      expression: "formItem.properties.expected_packets"
    }
  })], 1)], 1), _vm.isEditForm ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_vm.formItem.parser && (_vm.formItem.parser.type === 'single' || _vm.formItem.parser.type === 'multi' || _vm.formItem.parser.type === 'function') ? _c(VCombobox, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypeVariables(_vm.formItem),
      "item-text": "variable",
      "item-value": "variable",
      "return-object": "",
      "hide-details": "auto",
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.batteryLevelVariable')
    },
    on: {
      "input": _vm.selectedBattery
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s((data.item || {}).variable))]), _c(VListItemSubtitle, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.unit')) + ":\n                  " + _vm._s((data.item || {}).value_type_name || _vm.$i18n_t('Common.notAvailable')) + "\n                ")])], 1)];
      }
    }], null, false, 3242520943),
    model: {
      value: _vm.formItem.properties.battery_level,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "battery_level", $$v);
      },
      expression: "formItem.properties.battery_level"
    }
  }) : _c(VCombobox, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.batteryLevelVariable'),
      "placeholder": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.selectParserFirst'),
      "hide-details": "auto",
      "disabled": ""
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.batteryLevelType'),
      "hide-details": "auto",
      "disabled": ""
    },
    model: {
      value: _vm.formItem.properties.battery_type,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "battery_type", $$v);
      },
      expression: "formItem.properties.battery_type"
    }
  })], 1)], 1) : _vm._e(), _vm.isEditForm ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving || !_vm.formItem.parser || _vm.formItem.parser && _vm.formItem.parser.type === 'unset',
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.batteryWarningLevel'),
      "hide-details": "auto",
      "autocomplete": "off",
      "type": "number",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.battery_warning_level,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "battery_warning_level", $$v);
      },
      expression: "formItem.properties.battery_warning_level"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving || !_vm.formItem.parser || _vm.formItem.parser && _vm.formItem.parser.type === 'unset',
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.batteryAlertLevel'),
      "hide-details": "auto",
      "autocomplete": "off",
      "type": "number",
      "required": ""
    },
    model: {
      value: _vm.formItem.properties.battery_alert_level,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "battery_alert_level", $$v);
      },
      expression: "formItem.properties.battery_alert_level"
    }
  })], 1)], 1) : _vm._e(), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-dtwin-attachments', {
    attrs: {
      "source": "devicetype",
      "attachments": (_vm.formItem.properties.manufacturer || {}).device_manual_file || []
    },
    on: {
      "update": _vm.attachmentsUpdated
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.installationNotes'),
      "hide-details": "auto",
      "autocomplete": "off",
      "required": "",
      "rows": "4"
    },
    model: {
      value: _vm.formItem.properties.notes,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "notes", $$v);
      },
      expression: "formItem.properties.notes"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextarea, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "disabled": _vm.formSaving,
      "label": _vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.highlights'),
      "hide-details": "auto",
      "autocomplete": "off",
      "required": "",
      "rows": "4"
    },
    model: {
      value: _vm.formItem.properties.highlights,
      callback: function ($$v) {
        _vm.$set(_vm.formItem.properties, "highlights", $$v);
      },
      expression: "formItem.properties.highlights"
    }
  })], 1)], 1), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.DeviceTypes.form.create.technicalSpecs')))]), _c(VRow, _vm._l(_vm.techSpecKeys, function (item, idx) {
    return _c(VCol, {
      key: `tech-spec-${idx}`,
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "disabled": _vm.formSaving,
        "label": _vm.$i18n_t(`NiotaClassic.DeviceTypes.form.create.${item.replace(/ /g, '')}`),
        "hide-details": "auto",
        "autocomplete": "off",
        "clearable": "",
        "required": ""
      },
      on: {
        "input": _vm.updateModel
      },
      model: {
        value: (_vm.formItem.properties.technical_specs || {})[item],
        callback: function ($$v) {
          _vm.$set(_vm.formItem.properties.technical_specs || {}, item, $$v);
        },
        expression: "(formItem.properties.technical_specs || {})[item]"
      }
    })], 1);
  }), 1), _c(VDivider, {
    staticClass: "ma-0 mt-4 mb-6 pa-0"
  }), _c(VExpansionPanels, {
    staticClass: "mb-4"
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_vm._v("JSON")]), _c(VExpansionPanelContent, [_c('pre', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.formItem))])])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };